import React, { FC } from 'react';
import { IconProps } from 'types';

export const EastTimorFlag: FC<IconProps> = ({ width, height }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="-3 -6 18 12">
      <path d="M15 6V-6H-3V6z" fill="#dc241f" />
      <path d="M-3-6V6l9-6z" fill="#ffc726" />
      <path d="M-3-6V6l6-6z" />
      <g transform="matrix(.671 -.335 .335 .671 -.75 0)">
        <g id="e">
          <g id="d">
            <path id="f" d="M0-2.1l-.65 2L.3.2z" fill="#fff" />
            <use transform="scale(-1 1)" width="24" height="12" />
          </g>
          <use transform="rotate(72)" width="24" height="12" />
        </g>
        <use transform="rotate(-72)" width="24" height="12" />
        <use transform="matrix(-.809 .588 -.588 -.809 0 0)" width="24" height="12" />
      </g>
    </svg>
  );
};
